export function commaSeparatedToNum(commaSeparatedStr: any): number {
  if (typeof commaSeparatedStr === "number") {
    return commaSeparatedStr;
  }
  if (Array.isArray(commaSeparatedStr) && commaSeparatedStr.length === 0) {
    return 0;
  }
  const numStr = commaSeparatedStr?.replace(/,/g, "");
  const num = parseFloat(numStr);
  return isNaN(num) ? 0 : num;
}
